export class Customer {
  public Id: number;
  public MembershipNumber: string;
  public MembershipStartDate: Date;
  public Photo: string;
  public FirstName: string;
  public LastName: string;
  public EmailAddress: string;
  public Birthday: Date;
  public IsDeactivated: boolean;
  public CreatedBy: number;
  public CreatedDate: Date;
  public UpdatedBy: number;
  public UpdatedDate: Date;
  public IsDeleted: boolean;
  public CustomerTypeId: number;
  public BusinessName: string;
  public BusinessNature: string;
  public JobTitle: string;
  public About: string;
  public LocationId: number;
  public SalesTax: number;
  public LevelProcessing: number;
  public SalesTaxType: string;
  public SupplierReferenceNumber: string;
  public CustomerRefID: string;
  public CustomerVATRegistrationNumber: string;
  public hasUpdates: boolean;
  public IsTaxExempt: boolean = false;
  public PaymentTerm?: string;
  public PaymentTermCount: number; 
}

export class CustomerAddress {
  public Id: number;
  public CustomerId: number;
  public ContactPersonId: number;
  public AddressType: number;
  public StreetAddress: string;
  public Address2: string;
  public County: string;
  public City: string;
  public State: string;
  public ZipCode: string;
  public CountryId: number;
  public IsDefault: boolean;
  public CreatedBy: number;
  public UpdatedBy: number;
  public IsDeleted: boolean;
  public ZipCodeError: boolean;
  public CountryName: string;
  public CountryCode: string;
}

export class CustomerPhone {
  public Id: number;
  public CustomerId: number;
  public ContactPersonId: number;
  public PhoneType: number;
  public PhoneNumber: string;
  public IsDefault: boolean;
  public CreatedBy: number;
  public UpdatedBy: number;
  public IsDeleted: boolean;
}

export class IndividualCustomerPhone {
  public Id: number;
  public CustomerId: number;
  public PhoneType: number;
  public ContactNumber: string;
  public IsDefault: boolean;
  public creator: any;
  public created: any;
  public updater: any;
  public isDeleted: boolean;
}

export class ContactPerson {
  public Id: number;
  public BusinessCustomerId: number;
  public FirstName: string;
  public LastName: string;
  public Department: string;
  public EmailAddress: string;
  public IsMainContact: boolean;
  public CreatedBy: number;
  public UpdatedBy: number;
  public IsDeleted: boolean;
  public PhoneType: number;
  public PhoneNumber: string;
  public FullAddress: string;
  public FullName: string;
  public AddressType: number;
}

export class ContactPersonComplete {
  public contactPerson: ContactPerson;
  public contactPhone: CustomerPhone;
  public contactAddress: CustomerAddress;
}

export class CustomerCardNumber {
  public Id: number;
  public CustomerId: number;
  public CreatedBy: number;
  public CreatedDate: Date;
  public UpdatedBy: number;
  public UpdatedDate: Date;
  public IsDeleted: boolean;
  public IsDefault: boolean;
  public Token: string;
  public CardLast4Digits: string;
  public CardBrand: string;
  public ExpMonth: number;
  public ExpYear: number;
  public CVN: string;
  public CardBrandTransactionId: string;
}

export class ServiceWorkCustomer {
  public Id: number;
  public FirstName: string;
  public LastName: string;
  public PhoneNumber1: string;
  public DefaultPhoneNumber: number;
  public EmailAddress: string;
  public StreetAddress: string;
  public County: string;
  public City: string;
  public State: string;
  public ZipCode: string;
}
